import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";

import { AlertSearchSchema } from "./-constants";

export const Route = createFileRoute("/_staff/accesses/_layout/alerts/")({
  validateSearch: zodValidator(AlertSearchSchema),
});
